export type ScanMode = 'verifyOnly' | 'printOnly' | 'verifyAndPrint';

export const SCAN_MODES = {
  verifyOnly: 'verifyOnly',
  printOnly: 'printOnly',
  verifyAndPrint: 'verifyAndPrint',
} as const satisfies Record<ScanMode, ScanMode>;

export const inPrintMode = (mode: ScanMode): boolean => mode === SCAN_MODES.printOnly || mode === SCAN_MODES.verifyAndPrint;

export const inVerifyMode = (mode: ScanMode): boolean => mode === SCAN_MODES.verifyOnly || mode === SCAN_MODES.verifyAndPrint;

export const inVerifyOnlyMode = (mode: ScanMode): boolean => mode === SCAN_MODES.verifyOnly;
